import { FC } from "react";
import { Form, Typography } from "antd";
import { RfxAnalysisOutput } from "../../../../types/ProjectTypes";
import { RfxVendorPicker } from "./RfxVendorPicker";

interface RfxVendorsTabProps {
    output: RfxAnalysisOutput;
    onChange: (output: RfxAnalysisOutput) => void;
}

/**
 * Admin form for picking the evaluated vendor candidates of an RFx analysis.
 * The picked keys are stored in `output.vendors[]` and promoted to
 * `ILRfxVendor` rows on ingestion.
 */
export const RfxVendorsTab: FC<RfxVendorsTabProps> = ({ output, onChange }) => {
    const keys = (output.vendors ?? []).map((v) => v.vendorKey);

    return (
        <div>
            <Typography.Paragraph type="secondary">
                Pick each vendor evaluated in this RFx. On ingestion, each becomes a
                candidate the user can select from to spawn deal-analysis projects.
            </Typography.Paragraph>
            <Form layout="vertical">
                <Form.Item label="Candidate vendors">
                    <RfxVendorPicker
                        value={keys}
                        onChange={(nextKeys) =>
                            onChange({
                                ...output,
                                vendors: nextKeys.map((vendorKey) => ({ vendorKey })),
                            })
                        }
                    />
                </Form.Item>
            </Form>
        </div>
    );
};
